import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=e3113bd0&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"
import style0 from "./Notice.vue?vue&type=style&index=0&id=e3113bd0&prod&lang=css&"
import style1 from "./Notice.vue?vue&type=style&index=1&id=e3113bd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3113bd0",
  null
  
)

export default component.exports